<template>

    <div class="">
        <v-select
            v-model="model"
            :options="vehicleRates"
            :clearable="false"
            placeholder="Select a Vehicle Rate"
            label="name"
            :disabled="vehicleRates.length <= 1"
        />

        <!-- currently this component is used exclusively in blade files in forms so this is needed -->
        <input type="hidden" name="vehicle_rate_id" :value="model?.id">

        <div v-if="errors?.length > 0" >
            <div class="alert alert-danger mt-2" role="alert" v-for="(error, index) in errors" :key="index">
                {{ error }}
            </div>
        </div>
    </div>

</template>

<script setup>

import { ref, onMounted } from 'vue';
import VSelect from 'vue-select';
import axios from 'axios';

const props = defineProps({
    old: {
        type: String,
        required: false
    },
    errors: {
        type: Array,
        required: false,
        default: () => []
    }
});

const model = defineModel({
    type: Object,
    default: () => null
});

const vehicleRates = ref([]);

// This endpoint gets literally all the vehicle rates
const generateAllRatesRoutes = () => {
    return route('api.movements.vehicles.rates');
};

const fetchVehicleRates = async () => {
    try {
        const { data } = await axios.get(generateAllRatesRoutes());
        vehicleRates.value = Array.isArray(data) ? data : Object.values(data);
         model.value = vehicleRates.value.length === 1 ? vehicleRates.value[0] : null;
    } catch (error) {
        console.log(error);
    }
};

onMounted(() => {
    fetchVehicleRates();

    if (props.old) {
        model.value = vehicleRates.value.find(rate => rate.id === props.old);
    }
});

</script>
